import { getUserInfo, getSelectedApiKey, setApisURLS } from "./api"; // ajustá el path según sea necesario

export const fetch_stream = async (
  endpoint,
  body,
  onChunk,
  endFunc = () => {},
  onError = (error) => console.error("Stream error:", error),
  isJson = true
) => {
  try {
    const apiKeys = await getUserInfo();
    const apiKey = getSelectedApiKey(apiKeys);

    const storedRole = sessionStorage.getItem("userRole");
    const role = storedRole ? JSON.parse(storedRole) : "dev";

    setApisURLS(role); // setea la baseURL adecuada

    const baseURL =
      role.toLowerCase().endsWith("prod")
        ? process.env.REACT_APP_API_URL_PROD
        : process.env.REACT_APP_API_URL;

    let headers = {};
    if (isJson) {
      body = JSON.stringify(body);
      headers["Content-Type"] = "application/json";
    }
    headers["X-Api-Key"] = apiKey;

    const response = await fetch(baseURL + endpoint, {
      method: "POST",
      headers: headers,
      body: body,
    });

    const reader = response.body.getReader();
    const stream = new ReadableStream({
      start(controller) {
        function procesarDatos() {
          reader.read().then(({ done, value }) => {
            if (done) {
              controller.close();
              return;
            }
            const mensaje = new TextDecoder("utf-8").decode(value);
            onChunk(mensaje);
            controller.enqueue(value);
            procesarDatos();
          });
        }
        procesarDatos();
      },
    });

    const finalResponse = new Response(stream);
    await finalResponse.text();
    endFunc();
  } catch (error) {
    onError(error);
  }
};

